exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".borderHide[data-v-130d1baa]{border-left:1px;border-right:1px;border-top:0;border-bottom:0}", ""]);

// exports
